// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"DropdownMenu_dropdown__vNxi_","menuContainer":"DropdownMenu_menuContainer__xsm8y","bottomStretch":"DropdownMenu_bottomStretch__VvZmu","menu":"DropdownMenu_menu__zmO_v"};